import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { getDistribuicao } from '../../../utils/crm/getDistribuicao';
// import { listCorretores, updateEscala } from '../../../controllers/crm/escalaController';
import { getDiaSemana } from '../../../utils/crm/getDiaSemana';
import { getOperEscala, setOperEscala } from '../../../controllers/crm/operescalaController';

export function CorretorIncluir(
  { setOpenCorretorIncluir,
    openCorretorIncluir,
    idconta,
    idusuario,
    setSnackbar,
    listEscalas,
    escala,
    hrInicial,
    setHrInicial,
    hrFinal,
    setHrFinal,
    nome,
  }) {

  const [load, setLoad] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [operador, setOperador] = useState()
  const [escalado, setEscalado] = useState(false)
  // const [corretores, setCorretores] = useState([])
  const [nomeOperador, setNomeOperador] = useState(nome)
  const [dtHoraInicial, setDtHoraInicial] = useState(ajustarHoraEscala(escala.hrinicial))
  const [dtHoraFinal, setDtHoraFinal] = useState(ajustarHoraEscala(escala.hrfinal))
  const [horariosValidos, setHorariosValidos] = useState(true)

  // Função para validar horários
  const validarHorarios = (horaIni, horaFim) => {
    if (!horaIni || !horaFim) return false;
    
    const hrInicialEscala = dayjs(escala.hrinicial);
    const hrFinalEscala = dayjs(escala.hrfinal);
    
    const horaInicialInformada = dayjs(horaIni);
    const horaFinalInformada = dayjs(horaFim);
    
    // Verifica se hora inicial não é menor que a hora inicial da escala
    if (horaInicialInformada.isBefore(hrInicialEscala)) {
      setSnackbar({ 
        severity: 'warning', 
        message: `Horário inicial não pode ser menor que ${hrInicialEscala.format('HH:mm')}` 
      });
      return false;
    }
    
    // Verifica se hora final não é maior que a hora final da escala
    if (horaFinalInformada.isAfter(hrFinalEscala)) {
      setSnackbar({ 
        severity: 'warning', 
        message: `Horário final não pode ser maior que ${hrFinalEscala.format('HH:mm')}` 
      });
      return false;
    }
    
    // Verifica se hora inicial é menor que hora final
    if (horaInicialInformada.isAfter(horaFinalInformada) || horaInicialInformada.isSame(horaFinalInformada)) {
      setSnackbar({ 
        severity: 'warning', 
        message: 'Horário inicial deve ser menor que o horário final' 
      });
      return false;
    }
    
    return true;
  };

  // Função para lidar com mudança no horário inicial
  const handleHorarioInicialChange = (novaHora) => {
    setDtHoraInicial(novaHora);
    const valido = validarHorarios(novaHora, dtHoraFinal);
    setHorariosValidos(valido);
  };

  // Função para lidar com mudança no horário final
  const handleHorarioFinalChange = (novaHora) => {
    setDtHoraFinal(novaHora);
    const valido = validarHorarios(dtHoraInicial, novaHora);
    setHorariosValidos(valido);
  };

  const handleNo = () => {
    setOpenCorretorIncluir(false);
  };
  
  const loadOperador = async () => {
    const dados = {
      idconta: idconta,
      idescala: escala.idescala,
      idoperador: idusuario
    }
    setDisabled(true)
    setLoad(true)
    // const list = await listCorretores(dados)
    const api = await getOperEscala(dados)
    if (api.status !== 200) {
      setOperador(null)
      setSnackbar({ severity: 'error', message: 'Falha ao carregar dados do operador!' });
      setDisabled(false)
      setLoad(false)
      return
    }
    else if (api.data) {
      setDtHoraInicial(ajustarHoraEscala(api.data.hrinicial))
      setDtHoraFinal(ajustarHoraEscala(api.data.hrfinal))
      setOperador(api.data)
    }
    setDisabled(false)
    setLoad(false)
  }

  function ajustarHoraEscala(date){
    if (date) {
      const hora = dayjs(dayjs(escala.diamesano).format('YYYY-MM-DD') + ' ' + dayjs(date).format('HH:mm'))
      return hora
    }
    return ''
  }

  
  const handleGravar = async () => {
    // Validar horários antes de gravar
    if (!validarHorarios(dtHoraInicial, dtHoraFinal)) {
      return;
    }

    try {
      setDisabled(true)
      setLoad(true)
      // const d = new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
      const dados = {
        idoperador: idusuario,
        idescala: escala.idescala,
        idconta: idconta,
        diamesano: escala.diamesano,
        version: operador ? operador.version : 0,
        versionescala: escala.version,
        historico: escala.historico,
        hrinicial: ajustarHoraEscala(dtHoraInicial),
        hrfinal: ajustarHoraEscala(dtHoraFinal),
        participar: operador ? !operador.isactive : true,
        idusuario: idusuario,
        nome: nomeOperador,
        inout: escala.inout,

      }
      const response = await setOperEscala(dados)
      if (response.status === 200) {
        escala.version = response.data.version
        setOperador(response.data.operescala[0])
        setSnackbar({ severity: 'success', message: 'Operação realizada com sucesso!' });
        await listEscalas()
      }
      else if (response.status === 201) {
        setSnackbar({ severity: 'error', message: 'Ocorreu uma alteração na escala, acesso concorrente, feche esta janela e abra novamente.' });
        listEscalas()
      }
      else if (response.status === 202) {
        setSnackbar({ severity: 'error', message: 'Operador com CRM desativado. Ativar Operador em Minha Conta.' });
        listEscalas()
      }
      else {
        setSnackbar({ severity: 'error', message: 'Falha ao realizar a operação! Tente novamente mais tarde.' });
      }
    }
    catch (error) {
      setSnackbar({ severity: 'error', message: 'Serviço fora do ar, tente novamente mais tarde.' });
    }
    finally {
      setDisabled(false)
      setLoad(false)
    }
  }

  useEffect(() => {
    loadOperador()
  }, [])

  useEffect(() => {
    if (operador) {
      if (operador.isactive) {
        setEscalado(true)
      }
      else {
        setEscalado(false)
      }
    }
  }, [operador])


  // Validar horários quando o componente carregar
  useEffect(() => {
    if (dtHoraInicial && dtHoraFinal) {
      const valido = validarHorarios(dtHoraInicial, dtHoraFinal);
      setHorariosValidos(valido);
    }
  }, [dtHoraInicial, dtHoraFinal]);

  return (
    <Dialog
      maxWidth="xs"
      open={openCorretorIncluir}
      onClose={handleNo}
    >
      {(load) && ((
        <div style={{ position: 'fixed', top: '50vh', left: '50vw' }}>
          <CircularProgress />
        </div>
      ))}
      <DialogTitle>
        <Typography variant="h4" component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
          {`${getDiaSemana(escala.diamesano).toLocaleUpperCase()} - ${new Date(escala.diamesano).toLocaleDateString()}`}
        </Typography>
        <Typography variant="h5" component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
          {`Distribuição: ${getDistribuicao(escala.tpdistribuicao)} - ${dayjs(escala.hrinicial).format('HH:mm')} / ${dayjs(escala.hrfinal).format('HH:mm')}`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container
          direction={'row'}
          minHeight={'120px'}
          maxWidth={'280px'}
        >
          <Grid container direction={'row'} >
            <Grid item mb={1} >
              <Typography variant="body1" fontSize={14} component="div" >
                Informe seu horário de disponibilidade para recebimento de leads:
              </Typography>
            </Grid>
            <Grid container direction={'row'} gap={1} justifyContent={'space-between'} >
              <Grid item >
                <TimePicker
                  label="Hr Inicial"
                  ampm={false}
                  value={dtHoraInicial}
                  onChange={handleHorarioInicialChange}
                  views={['hours', 'minutes']}
                  format="HH:mm"
                  disabled={escalado}
                  sx={{ width: '100px' }}
                  minTime={dayjs(escala.hrinicial)}
                  maxTime={dayjs(escala.hrfinal)}
                />
              </Grid>
              <Grid item >
                <TimePicker
                  label="Hr Final"
                  value={dtHoraFinal}
                  ampm={false}
                  onChange={handleHorarioFinalChange}
                  views={['hours', 'minutes']}
                  format="HH:mm"
                  disabled={escalado}
                  sx={{ width: '100px' }}
                  minTime={dayjs(escala.hrinicial)}
                  maxTime={dayjs(escala.hrfinal)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={'flex-end'} gap={1} m={1} alignItems={'center'}>
          <Typography variant="body1" fontFamily={'Roboto'} fontSize={12} color={escalado ? 'error.main' : 'error.main'} >
            {escalado ? 'Você está participando: ' : ''}
          </Typography>
          {escalado && (
            <Button variant="contained"
              color='error'
              disabled={disabled || !horariosValidos} 
              size='small'
              onClick={() => handleGravar()}
            >
              Não Participar
            </Button>
          )}
          {!escalado && (
            <Button variant="contained"
              color='success'
              disabled={disabled || !horariosValidos} 
              size='small'
              onClick={() => handleGravar()}
            >
              Participar
            </Button>
          )}
          <Button variant="contained"
            onClick={() => handleNo()}
            disabled={disabled} size='small'>
            Fechar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};